export enum MAIN_PAGES {
  HOME     = 'ToDo',
  CALENDAR = 'カレンダー',
  LOG      = '操作履歴',
  CONFIG   = '設定',
}

export enum PATH_PAGES {
  HOME     = '/',
  CALENDAR = '/calendar',
  LOG      = '/logs',
  CONFIG   = '/conf',
}